import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-vergaderendigitaal',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconVergaderendigitaal {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M29.04 17.05h-7.08c-1.65 0-2.96 1.25-2.96 2.8v1.16c0 .55.45 1 1 1h11c.55 0 1-.45 1-1v-1.44c-.15-1.41-1.41-2.52-2.96-2.52M22 11.52c0 1.94 1.57 3.5 3.51 3.5s3.51-1.57 3.51-3.5-1.57-3.5-3.51-3.5S22 9.59 22 11.52m-7.96 5.53H6.96C5.31 17.05 4 18.3 4 19.85v1.16c0 .55.45 1 1 1h11c.55 0 1-.45 1-1v-1.44c-.15-1.41-1.41-2.52-2.96-2.52m-3.54-2.03c1.94 0 3.51-1.57 3.51-3.5s-1.57-3.5-3.51-3.5-3.51 1.57-3.51 3.5 1.57 3.5 3.51 3.5M27 34H9c0-1.1.9-2 2-2h3v-3h8v3h3c1.1 0 2 .9 2 2m6-32H3C1.34 2 0 3.34 0 5v19.01c0 1.66 1.34 3 3 3h30c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3m1 22.01c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1v-19c0-.55.45-1 1-1h30c.55 0 1 .45 1 1z"/>
</svg>

    );
  }
}
